import { InfoAlert } from "./styles";
import closeIcon from "./imgs/close-icon.svg";
import headerImg from "./imgs/live_mascot_experience_banner.webp";
import appStore from "./imgs/app-store.svg";
import googlePlay from "./imgs/google-play.svg";
import { AppStoreLinks } from "./balance.styles";

const LiveMascotExperienceModal = ({ onClose }) => {
  const appStoreLinks = (appStoreUrl, playStoreUrl) => {
    return (
      <AppStoreLinks>
        <img
          src={appStore}
          alt="app-store"
          onClick={() => window.open(appStoreUrl, "_blank")}
        />
        <img
          src={googlePlay}
          alt="play-store"
          onClick={() => window.open(playStoreUrl, "_blank")}
        />
      </AppStoreLinks>
    );
  };

  return (
    <InfoAlert>
      <div className="inner-container">
        <div className="img-container">
          <img src={headerImg} alt="header" />
          <h2>{"Live Mascot Experience"}</h2>
        </div>
        <div className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </div>
        <div className="scroll-view">
          <div className="section">
            <p>
              {
                "Watch the magic of the UEFA Champions League Final unfold from a completely new perspective. This live 180° experience follows the player mascots as they walk onto the pitch alongside the players in Budapest 2026, capturing the anticipation, emotion, and once-in-a-lifetime energy of this iconic moment."
              }
            </p>
          </div>
          <div className="section bg-black">
            <p>
              {
                "Available exclusively to Mastercard invitees, this immersive stream brings you closer than ever to the children’s journey, from backstage preparation to the unforgettable walkout under the stadium lights."
              }
            </p>
          </div>
          <div className="section">
            <p>
              {
                "Immerse yourself in the Player Mascot journey using the Virtual Reality headsets available at the central activation zone."
              }
            </p>
          </div>
          <div className="section bg-black">
            <p className="bold">{"Download the app below"}</p>
            <div className="group btn-group">
              {appStoreLinks(
                "https://apps.apple.com/es/app/uefa-vr/id6757922584",
                "https://play.google.com/store/apps/details?id=com.ybvr.androidnativeclient.uefaxr&pcampaignid=web_share",
              )}
            </div>
            <p>
              LIVE - UCL PRICELESS EXPERIENCE code: <b>PRICELESS2026</b>
            </p>
          </div>
          
        </div>
      </div>
    </InfoAlert>
  );
};

export default LiveMascotExperienceModal;
